import {
  RSET_STATE_ANSWERS,
  CLEAR_STATE_ANSWERS,
  SET_ADDITIONAL_ANSWERS,
  SET_EXTRA_ANSWER,
} from "./constants";

export const EXPLORE_GUIDES_INITIAL_STATE = {
  answers: {},
};

function exploreGuideReducer(
  state = EXPLORE_GUIDES_INITIAL_STATE,
  action: any
) {
  switch (action.type) {
    case RSET_STATE_ANSWERS: {
      return {
        ...state,
        answers: { ...action.value },
      };
    }
    case SET_ADDITIONAL_ANSWERS: {
      return {
        ...state,
        additionalAnswers: { ...action.value },
      };
    }
    case SET_EXTRA_ANSWER: {
      return {
        ...state,
        extraAnswer: { ...action.value },
      };
    }
    case CLEAR_STATE_ANSWERS: {
      return { ...EXPLORE_GUIDES_INITIAL_STATE };
    }
    default:
      return state;
  }
}

export default exploreGuideReducer;
